import { render, staticRenderFns } from "./warehouseClassify.vue?vue&type=template&id=42e06b94&"
import script from "./warehouseClassify.vue?vue&type=script&lang=js&"
export * from "./warehouseClassify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports